import React from 'react';
import PropTypes from 'prop-types';
import { getPartyColor } from '../../utils/theme';

/**
 * PartyBadge component for displaying political party information
 * 
 * @param {Object} props - Component props
 * @param {string} props.party - Party code (e.g., 'ALP', 'LIB')
 * @param {number} [props.margin] - Electoral margin percentage (optional)
 * @param {string} [props.size] - Size of the badge ('sm', 'md', 'lg')
 * @returns {JSX.Element} Rendered component
 */
const PartyBadge = ({ party, margin, size = 'md' }) => {
  const color = getPartyColor(party);
  
  // Size classes
  const sizeClasses = {
    'sm': 'px-2 py-0.5 text-xs',
    'md': 'px-3 py-1 text-sm',
    'lg': 'px-4 py-1.5 text-base'
  };
  
  return (
    <div className="flex items-center gap-2">
      <div 
        className={`text-white ${sizeClasses[size]} rounded-full font-bold`}
        style={{ backgroundColor: color }}
      >
        {party}
      </div>
      {margin !== undefined && (
        <span className={size === 'sm' ? 'text-xs' : 'text-sm'}>
          {`${margin}% margin`}
        </span>
      )}
    </div>
  );
};

PartyBadge.propTypes = {
  party: PropTypes.string.isRequired,
  margin: PropTypes.number,
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
};

export default PartyBadge; 